export default {
      id: "color_hh-usage",
      viewBox: "0 0 106 100",
      url: __webpack_public_path__ + "sprite.svg#color_hh",
      toString: function () {
        return this.url;
      }
    }